import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Dashboard, DashboardItem } from "../model/top.model";

@Injectable()
export class DashboardData {
  private dashboards: Array<Dashboard> = [];

  // hardcoded mocking data
  private defaultDashboards: Array<Dashboard> = [
    {
      uuid: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
      name: "MY_HOURS",
      jobRoles: [],
      icon: "clock",
      dashboardItems: [
        {
          uuid: "d394527e-84f8-4440-8754-af814d6c618f",
          dashboard_id: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
          name: "Urenoverzicht",
          moduleName: "timeRegistrationOverview",
          jobRoles: [],
          // }, {
          // 	uuid: "bc67d8aa-85f3-47c2-a3b0-babe5482dec0",
          // 	dashboard_id: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
          // 	name: "Uren registreren",
          // 	moduleName: "timeRegistration",
          // 	jobRoles: ['Productmanager', 'Voorman', 'Directeur']
        },
      ],
      // }, {
      // 	uuid: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
      // 	name: "MY_LEAVE",
      // 	jobRoles: ['Productmanager', 'Voorman', 'Directeur'],
      // 	icon: "home",
      // 	dashboardItems: [{
      // 		uuid: "8540780f-7602-42f8-b8ad-385a0ebed722",
      // 		dashboard_id: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
      // 		name: "Verlofoverzicht",
      // 		moduleName: "leaveRegistrationOverview",
      // 		jobRoles: ['Productmanager', 'Voorman', 'Directeur']
      // 	}, {
      // 		uuid: "e90f3c4b-c1b6-47cc-a39e-7016b628e8ee",
      // 		dashboard_id: "c191a549-3a65-46cc-b6cb-2a8525d09dc9",
      // 		name: "Verlof aanvragen",
      // 		moduleName: "leaveRegistration",
      // 		jobRoles: ['Productmanager', 'Voorman', 'Directeur']
      // }]
    },
  ];

  constructor(public storage: Storage) { }

  getDashboards() {
    // get Dashboards from local storage. Make if there are none
    return new Promise((resolve) => {
      this.storage.get("dashboards").then((data) => {
        if (data) {
          this.dashboards = JSON.parse(data);
          resolve(this.dashboards);
        } else {
          // hardcoded data
          // clone to make it a unique object
          this.dashboards = this.cloneObject(this.defaultDashboards);
          resolve(this.dashboards);
        }
      });
    });
  }

  /**
   *
   * @param newDashboard
   */
  createDashboard(newDashboard: Dashboard): Promise<Array<Dashboard>> {
    // search for dashboard and overwrite
    this.dashboards.push(newDashboard);
    // save data in local storage for now
    return this.storage.set("dashboards", JSON.stringify(this.dashboards));
  }

  /**
   *
   * @param dashboard
   */
  deleteDashboard(dashboard: Dashboard): Promise<Array<Dashboard>> {
    // search for dashboard and delete
    let foundIndex = this.dashboards.indexOf(dashboard);
    if (foundIndex > -1) {
      this.dashboards.splice(foundIndex, 1);
      // save data in local storage for now
      return this.storage.set("dashboards", JSON.stringify(this.dashboards));
    } else {
      throw new Error("deleteDashboard: dashboard not found");
    }
  }

  /**
   *
   * @param alteredDashboard
   */
  setDashboard(alteredDashboard: Dashboard): Promise<Array<Dashboard>> {
    // search for dashboard and overwrite
    for (let dashboardKey in this.dashboards) {
      if (this.dashboards[dashboardKey].uuid == alteredDashboard.uuid) {
        this.dashboards[dashboardKey] = alteredDashboard;
        break;
      }
    }
    // save data in local storage
    return this.storage.set("dashboards", JSON.stringify(this.dashboards));
  }

  /**
   *
   * @param alteredDashboardItem
   */
  setDashboardItem(
    alteredDashboardItem: DashboardItem
  ): Promise<Array<Dashboard>> {
    // search for item and overwrite
    for (let dashboardKey in this.dashboards) {
      if (
        this.dashboards[dashboardKey].uuid == alteredDashboardItem.dashboard_id
      ) {
        for (let itemKey in this.dashboards[dashboardKey].dashboardItems) {
          if (
            this.dashboards[dashboardKey].dashboardItems[itemKey].uuid ==
            alteredDashboardItem.uuid
          ) {
            this.dashboards[dashboardKey].dashboardItems[
              itemKey
            ] = alteredDashboardItem;
            break;
          }
        }
      }
    }
    // save data in local storage
    return this.storage.set("dashboards", JSON.stringify(this.dashboards));
  }

  /**
   *
   * @param dashboardItem
   */
  deleteDashboardItem(dashboardItem: DashboardItem): Promise<Array<Dashboard>> {
    // search for item and overwrite
    for (let dashboardKey in this.dashboards) {
      if (this.dashboards[dashboardKey].uuid == dashboardItem.dashboard_id) {
        let foundIndex = this.dashboards[dashboardKey].dashboardItems.indexOf(
          dashboardItem
        );
        if (foundIndex > -1) {
          this.dashboards[dashboardKey].dashboardItems.splice(foundIndex, 1);
          // save data in local storage for now
          return this.storage.set(
            "dashboards",
            JSON.stringify(this.dashboards)
          );
        } else {
          throw new Error("deleteDashboardItem: item not found");
        }
      }
    }
  }

  /**
   * Helper method to make a unique clone of an object
   */
  cloneObject(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
}



// WEBPACK FOOTER //
// ./src/providers/dashboard-data.ts